import React from "react";

import { getIcon } from "../../../utils/getIcon";

import type { ConnectedIntegrationDetail } from "../../types/integrations";

interface AccountCardProps {
  account: ConnectedIntegrationDetail;
  sourceId: string;
  children?: React.ReactNode;
  className?: string;
}

export function AccountCard({
  account,
  sourceId,
  children,
  className = "bg-neutral-100 dark:bg-neutral-900 rounded-xl p-5",
}: AccountCardProps) {
  const formatDate = (timestamp: number) => {
    return new Date(timestamp * 1000).toLocaleDateString("en-US", {
      month: "long",
      day: "numeric",
      year: "numeric",
    });
  };

  return (
    <div className={className}>
      <div className="flex items-center justify-between w-full">
        <div className="flex items-start gap-2.5 flex-1 min-w-0">
          <div className="w-6 h-6 bg-white dark:bg-neutral-700 rounded overflow-hidden flex items-center justify-center flex-shrink-0 mt-0.5">
            <div className="flex items-center justify-center text-zinc-600 dark:text-zinc-300 text-sm">
              {getIcon(sourceId)}
            </div>
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold text-zinc-900 dark:text-white truncate leading-[23px] mb-0">
              {account.verifiable_id}
            </div>
            <div className="text-sm text-zinc-500 dark:text-zinc-400 leading-[23px] line-clamp-2">
              <span className="font-normal">Connected since</span>
              <span className="font-semibold">
                {" "}
                {formatDate(account.created_at)}
              </span>
            </div>
          </div>
        </div>
        {children && (
          <div className="flex gap-2 ml-4 flex-shrink-0">{children}</div>
        )}
      </div>
    </div>
  );
}
